import React from 'react';

/* eslint-disable */
const IconDownload = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.30273 18.81898"><path d="M9.06445,11.584a.9002.9002,0,0,0,1.17188,0l3.5-3A.90034.90034,0,1,0,12.56445,7.2168L10.55078,8.943V.90039a.90039.90039,0,0,0-1.80078,0V8.943L6.73633,7.2168A.90034.90034,0,0,0,5.56445,8.584Z" /><path d="M18.40234,11.96875a.90065.90065,0,0,0-.90039.90039v3.22168a.93113.93113,0,0,1-.93554.92285H2.72949a.92783.92783,0,0,1-.92871-.917V12.86914a.90039.90039,0,0,0-1.80078,0v3.2334a2.73312,2.73312,0,0,0,2.72461,2.71191h13.8291a2.51266,2.51266,0,0,0,1.93555-.78711,2.71267,2.71267,0,0,0,.81347-1.93066V12.86914A.90065.90065,0,0,0,18.40234,11.96875Z" /></svg>
);

export default IconDownload;
